const ACCESS_ROUTE = '/users/access/generate'

export { ACCESS_ROUTE }
